export enum AiChatType {
  COMPLEX = 'complex',
  TEXT = 'text',
}
